import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

export const YourWayIcon: FunctionComponent<IIconProps> = ({ ...props }) => (
  <Icon {...{ viewBox: '0 0 18 18', ...props }}>
    <Path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.5,4.8c.95,0,1.7.7,1.8,1.6v.14s0,10,0,10c0,.95-.7,1.7-1.6,1.8h-.14s-4.6,0-4.6,0c-.95,0-1.7-.7-1.8-1.6v-.14s0-10,0-10c0-.95.7-1.7,1.6-1.8h.14s4.6,0,4.6,0ZM15.5,5.6h-4.6c-.42,0-.75.3-.8.7v.1s0,10,0,10c0,.42.3.75.7.8h.1s4.6,0,4.6,0c.42,0,.75-.3.8-.7v-.1s0-10,0-10c0-.4-.3-.75-.7-.8h-.1s0,0,0,0ZM13.2,2.4c.95,0,1.7.72,1.8,1.62v.14s0,1.06,0,1.06h-.96v-1.06c0-.42-.3-.76-.7-.82h-.1s-11.6,0-11.6,0c-.4,0-.74.3-.78.72v.1s0,7.46,0,7.46h8.56v.96h-.01c-.09.18-.26.3-.46.35h-.1s-2.54,0-2.54,0c-.21,0-.4-.09-.51-.28l-.05-.09H1.04v1.2c0,.4.3.74.7.78h.1s9.2,0,9.2,0v.96H2.04c-.95,0-1.7-.7-1.8-1.6v-.14s0-2.16,0-2.16h1.38v-7.46c0-.92.7-1.66,1.56-1.74h.14s11.6,0,11.6,0ZM12.8,6.8c.12,0,.22.08.23.2,0,.12-.08.22-.2.23,0,0-.02,0-.03,0-.12,0-.2-.11-.2-.23,0-.11.09-.19.2-.2M15.2,6.82c.11,0,.2.09.2.2,0,.09-.06.18-.15.2h-.05s-1.7,0-1.7,0c-.11,0-.2-.09-.2-.2,0-.09.06-.17.15-.2h.05s1.7,0,1.7,0Z"
      clipRule="evenodd"
    />
    <Path
      fill="currentColor"
      fillRule="evenodd"
      d="M14,9.6c.01.06.03.13.06.19l.05.09.66,1.15c.07.13.12.28.12.42.69.18,1.2.57,1.2,1.02,0,.63-.94,1.15-2.1,1.15s-2.1-.52-2.1-1.15c0-.45.48-.83,1.2-1.02,0,.14.02.28.07.42l.05.09.66,1.15c.03.06.06.12.08.18l.02.09.03-.05c.15-.26.16-.56.04-.83l-.04-.09-.54-.92-.04-.09c-.09-.24-.09-.51,0-.74l.04-.09.03-.05c.01.06.03.13.06.19l.05.09.78,1.36c.03.06.06.12.08.18l.03.09.03-.05c.15-.26.16-.56.04-.83l-.04-.09-.52-.92c-.15-.26-.16-.56-.04-.83l.04-.09.03-.05Z"
      clipRule="evenodd"
    />
  </Icon>
)
